// 报告状态
const BRIEF_STATUS = [
  {
    value: 0,
    label: "草稿",
  },
  {
    value: -1,
    label: "退回修改",
  },
  {
    value: 1,
    label: "提交待审核",
  },
  {
    value: 2,
    label: "已经发布",
  },
];

const PREDICTION = [
  {
    value: 0,
    label: "未披露",
  },
  {
    value: 1,
    label: "非上市披露",
  },
  {
    value: 2,
    label: "上市披露",
  },
];

const AUTHORITY = [
  {
    value: 0,
    label: "非权威",
  },
  {
    value: 1,
    label: "第三方",
  },
  {
    value: 2,
    label: "权威",
  },
];

const SOURCE = [
  {
    value: 0,
    label: "沙利文研究院",
  },
  {
    value: 1,
    label: "头豹研究院",
  },
];

const REPORT_TYPE = [
  {
    label: "一级市场",
    value: "一级市场",
  },
  {
    label: "二级市场",
    value: "二级市场",
  },
];

const BRIEF_ATTRIBUTE = [
  {
    value: 3,
    label: "简报",
  },
  {
    value: 0,
    label: "短报告",
  },
  {
    value: 1,
    label: "普通报告",
  },
  {
    value: 2,
    label: "深度报告",
  },
  {
    value: 4,
    label: "白皮书",
  },
  {
    value: 5,
    label: "头豹推荐",
  },
];

const SIZE_TYPE = [
  {
    value: 0,
    label: "普通",
  },
  {
    value: 1,
    label: "统计后（算法）数据",
  },
];

const STATUS = [
  {
    value: 0,
    label: "草稿",
  },
  {
    value: -1,
    label: "退回修改",
  },
  {
    value: 1,
    label: "提交待审核",
  },
  {
    value: 2,
    label: "审核通过",
  },
];

const ILL_SOURCE = [
  { value: "头豹研究院绘制" },
  { value: "沙利文研究院绘制" },
  { value: "tbTEAM软件采编，头豹数据中心编制" },
];

const UNIT_NAME = [
  // 货币
  { value: "人民币元", label: "人民币元" },
  { value: "港币", label: "港币" },
  { value: "美元", label: "美元" },
  { value: "日元", label: "日元" },
  { value: "欧元", label: "欧元" },
  { value: "英镑", label: "英镑" },
  // 计量单位
  { value: "公斤", label: "公斤" },
  { value: "升", label: "升" },
  { value: "平方米", label: "平方米" },
  { value: "米", label: "米" },
  // 量词
  { value: "人", label: "人" },
  { value: "家", label: "家" },
  { value: "辆", label: "辆" },
  { value: "个", label: "个" },
  { value: "件", label: "件" },
  { value: "套", label: "套" },
  { value: "只", label: "只" },
  { value: "枚", label: "枚" },
  { value: "把", label: "把" },

  { value: "公顷", label: "公顷" },
  { value: "平方公里", label: "平方公里" },
  { value: "%", label: "%" },

  // 其他
  { value: "人次", label: "人次" },
  { value: "公吨/人", label: "公吨/人" },
  { value: "公吨/天", label: "公吨/天" },
];

const UNITS = [
  {
    value: 1,
    label: "个",
  },
  {
    value: Math.pow(10, 1),
    label: "十",
  },
  {
    value: Math.pow(10, 2),
    label: "百",
  },
  {
    value: Math.pow(10, 3),
    label: "千",
  },
  {
    value: Math.pow(10, 4),
    label: "万",
  },
  {
    value: Math.pow(10, 5),
    label: "十万",
  },
  {
    value: Math.pow(10, 6),
    label: "百万",
  },
  {
    value: Math.pow(10, 7),
    label: "千万",
  },
  {
    value: Math.pow(10, 8),
    label: "亿",
  },
  {
    value: Math.pow(10, 9),
    label: "十亿",
  },
  {
    value: Math.pow(10, 10),
    label: "百亿",
  },
  {
    value: Math.pow(10, 11),
    label: "千亿",
  },
  {
    value: Math.pow(10, 12),
    label: "万亿",
  },
];

const getLabel = (num, arr) => {
  for (const i in arr) {
    if (Number(arr[i].value) === num) {
      return arr[i].label;
    }
  }
};

const pickerDate = (d) => {
  const end = new Date();
  const start = new Date();
  start.setTime(start.getTime() - 3600 * 1000 * 24 * d);
  return [start, end];
};

const pickerOptions = {
  shortcuts: [
    {
      text: "最近一周",
      onClick(picker) {
        picker.$emit("pick", pickerDate(7));
      },
    },
    {
      text: "最近一个月",
      onClick(picker) {
        picker.$emit("pick", pickerDate(30));
      },
    },
    {
      text: "最近三个月",
      onClick(picker) {
        picker.$emit("pick", pickerDate(90));
      },
    },
  ],
};

const INDIVIDUAL_GENDER = [
  { value: 0, label: "男" },
  { value: 1, label: "女" },
  { value: 2, label: "未知" },
];

const IllSource = [
  { value: "头豹研究院绘制" },
  { value: "沙利文研究院绘制" },
  { value: "tbTEAM软件采编，头豹数据中心编制" },
];
const _CLASS = [
  { value: -1, label: "文本" },
  { value: 0, label: "图说" },
  { value: 1, label: "表说" },
  { value: 2, label: "size" },
  { value: 3, label: "专家说" },
];

const ARTICLE_TYPE = [
  { value: 0, label: "新闻稿" },
  { value: 1, label: "园区" },
  { value: 2, label: "会议" },
  { value: 3, label: "项目", disabled: true },
];

const COLORS = [
  "#0e72cc",
  "#6ca30f",
  "#f59311",
  "#fa4343",
  "#16afcc",
  "#85c021",
  "#d12a6a",
  "#0e72cc",
  "#6ca30f",
  "#f59311",
  "#fa4343",
  "#16afcc",
];

// memo类型
const MEMO_CLASS = [
  {
    value: 0,
    label: "一手",
  },
  {
    value: 1,
    label: "二手",
  },
  {
    value: 2,
    label: "数据模型",
  },
  {
    value: 3,
    label: "其他",
  },
];

const VIDEO_TYPE = [
  { value: 1, label: "头豹直说" },
  { value: 2, label: "研豹解读" },
  { value: 3, label: "趣味播豹" },
  { value: 4, label: "产鲸快豹" },
  { value: 5, label: "慧智星短视频" },
  { value: 6, label: "特邀专区" },
  { value: 7, label: "百文一见短视频" },
];

const INDUSTRY_LABEL = [
  {
    id: 201,
    name: "能源业",
    children: [
      {
        id: 201001,
        name: "石油天然气",
      },
      {
        id: 201002,
        name: "煤炭",
      },
    ],
  },
  {
    id: 202,
    name: "原材料业",
    children: [
      {
        id: 202001,
        name: "黄金及贵金属",
      },
      {
        id: 202002,
        name: "一般金属及矿石",
      },
      {
        id: 202003,
        name: "原材料",
      },
    ],
  },
  {
    id: 10,
    name: "工业",
    children: [
      {
        id: 1010,
        name: "工业制造",
      },
      {
        id: 1020,
        name: "工用运输",
      },
      {
        id: 1030,
        name: "工用支援",
      },
    ],
  },
  {
    id: 23,
    name: "非必需性消费",
    children: [
      {
        id: 2310,
        name: "汽车",
      },
      {
        id: 2320,
        name: "家用电器及用品",
      },
      {
        id: 2330,
        name: "纺织及服饰",
      },
      {
        id: 2340,
        name: "旅游及消闲设施",
      },
      {
        id: 2350,
        name: "媒体及娱乐",
      },
      {
        id: 2360,
        name: "支援服务",
      },
      {
        id: 2370,
        name: "专业零售",
      },
    ],
  },
  {
    id: 25,
    name: "必须性消费",
    children: [
      {
        id: 2510,
        name: "食物饮品",
      },
      {
        id: 2520,
        name: "农业产品",
      },
      {
        id: 2530,
        name: "消费商主要零售商",
      },
    ],
  },
  {
    id: 28,
    name: "医疗保健业",
    children: [
      {
        id: 2810,
        name: "药品及生物科技",
      },
      {
        id: 2820,
        name: "医疗保健设备和服务",
      },
    ],
  },
  {
    id: 35,
    name: "电讯业",
    children: [
      {
        id: 3500,
        name: "电讯",
      },
    ],
  },
  {
    id: 40,
    name: "公共事业",
    children: [
      {
        id: 4000,
        name: "公共事业",
      },
    ],
  },
  {
    id: 50,
    name: "金融",
    children: [
      {
        id: 5010,
        name: "银行",
      },
      {
        id: 5020,
        name: "保险",
      },
      {
        id: 5030,
        name: "其他金融",
      },
    ],
  },
  {
    id: 60,
    name: "地产建筑业",
    children: [
      {
        id: 6010,
        name: "地产",
      },
      {
        id: 6020,
        name: "建筑",
      },
    ],
  },
  {
    id: 70,
    name: "资讯科技业",
    children: [
      {
        id: 7010,
        name: "资讯科技器材",
      },
      {
        id: 7020,
        name: "软件服务",
      },
      {
        id: 7030,
        name: "半导体",
      },
    ],
  },
  {
    id: 80,
    name: "综合性企业",
    children: [
      {
        id: 8000,
        name: "综合企业",
      },
    ],
  },
];

const PLATE_LABEL = [
  {
    id: 1,
    name: "在线营销",
  },
  {
    id: 2,
    name: "新餐饮",
  },
  {
    id: 3,
    name: "智能家居",
  },
  {
    id: 4,
    name: "智能终端产业",
  },
  {
    id: 5,
    name: "人机交互",
  },
  {
    id: 6,
    name: "游戏电竞",
  },
  {
    id: 7,
    name: "SAAS服务",
  },
  {
    id: 8,
    name: "金融科技",
  },
  {
    id: 9,
    name: "物业管理",
  },
  {
    id: 10,
    name: "教育类",
  },
  {
    id: 11,
    name: "中概股",
  },
  {
    id: 12,
    name: "元宇宙",
  },
  {
    id: 13,
    name: "碳中和",
  },
  {
    id: 14,
    name: "医疗健康",
  },
  {
    id: 15,
    name: "生物医药B",
  },
  {
    id: 16,
    name: "光伏",
  },
];
const AUTH_OPTIONS = [
  {
    value: 1,
    label: "特殊",
  },
  {
    value: 4,
    label: "同步",
  },
  {
    value: 2,
    label: "内容",
    children: [
      {
        value: 21,
        label: "阅读",
      },
      {
        value: 22,
        label: "修改",
      },
      {
        value: 23,
        label: "审批",
      },
    ],
  },
  {
    value: 3,
    label: "视频",
    children: [
      {
        value: 31,
        label: "阅读",
      },
      {
        value: 32,
        label: "修改",
      },
      {
        value: 33,
        label: "审批",
      },
    ],
  },
  {
    value: 5,
    label: "文章",
    children: [
      {
        value: 51,
        label: "阅读",
      },
      {
        value: 52,
        label: "修改",
      },
      {
        value: 53,
        label: "审批",
      },
    ],
  },
];

const AUTH = {
  SPECAIL: 1,
  REPORT_READ: 21, // 报告包含了其他元素的内容
  REPORT_EDIT: 22,
  REPORT_REVIEW: 23,
  VIDEO_READ: 31,
  VIDEO_EDIT: 32,
  VIDEO_REVIEW: 33,
  ARTICLE_READ: 51,
  ARTICLE_EDIT: 52,
  ARTICLE_REVIEW: 53,
};
export default {
  _CLASS,
  STATUS,
  BRIEF_STATUS,
  BRIEF_ATTRIBUTE,
  UNIT_NAME,
  PREDICTION,
  AUTHORITY,
  UNITS,
  SIZE_TYPE,
  pickerOptions,
  pickerDate,
  SOURCE,
  getLabel,
  REPORT_TYPE,
  ILL_SOURCE,
  IllSource,
  INDIVIDUAL_GENDER,
  COLORS,
  ARTICLE_TYPE,
  MEMO_CLASS,
  VIDEO_TYPE,
  INDUSTRY_LABEL,
  PLATE_LABEL,
  AUTH_OPTIONS,
  AUTH,
};
